{
  "LOGIN": {
    "TITLE": "Hyr në qendrën e kontaktit",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Please enter a valid email address"
    },
    "PASSWORD": {
      "LABEL": "Password",
      "PLACEHOLDER": "Password"
    },
    "API": {
      "SUCCESS_MESSAGE": "Login successful",
      "ERROR_MESSAGE": "Could not connect to chat server. Please try again.",
      "UNAUTH": "Username or password is incorrect. Please try again.",
      "ACCOUNT_DEACTIVATED": "Llogaria juaj është çaktivizuar. Kontaktoni administratorin tuaj.",
      "PASSWORD_LOGIN_DISABLED": "Hyrja me fjalëkalim është çaktivizuar për llogarinë tuaj. Identifikohuni duke përdorur OAuth (p.sh. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Login with Google",
      "BUSINESS_ACCOUNTS_ONLY": "Please use your company email address to login",
      "NO_ACCOUNT_FOUND": "We couldn't find an account for your email address."
    },
    "FORGOT_PASSWORD": "Forgot your password?",
    "CREATE_NEW_ACCOUNT": "Create a new account",
    "SUBMIT": "Login"
  }
}
